<div
  class="editor-sidebar-shell tw-flex tw-h-full tw-min-h-0 tw-overflow-hidden tw-bg-white"
  [class.is-panel-open]="isSidebarPanelVisible()"
>
  <nav
    class="editor-sidebar-nav tw-flex tw-w-[var(--editor-sidebar-nav-width)] tw-flex-none tw-flex-col tw-items-center tw-gap-2 tw-bg-gray-50 tw-pt-3"
    aria-label="Editor menu"
  >
    @for (item of sidebarItems; track item.id) {
      @let activeSidebarItem = getActiveSidebarItem();
      <button
        type="button"
        id="editor-sidebar-{{ item.id }}-button"
        class="editor-sidebar-nav__item tw-flex tw-min-h-[76px] tw-w-full tw-cursor-pointer tw-flex-col tw-items-center tw-justify-center tw-gap-[6px] tw-border-0 tw-bg-transparent tw-px-1 tw-py-1"
        [class.is-active]="activeSidebarItem === item.id"
        [style.--editor-sidebar-active-color]="item.activeColor"
        [attr.aria-current]="activeSidebarItem === item.id ? 'page' : null"
        [attr.aria-label]="item.ariaLabel"
        [matTooltip]="item.label"
        matTooltipPosition="right"
        (click)="selectSidebarItem(item.id)"
      >
        <span
          class="editor-sidebar-nav__icon-frame tw-flex tw-h-16 tw-w-16 tw-items-center tw-justify-center tw-rounded-xl"
        >
          <mat-icon
            aria-hidden="true"
            [svgIcon]="item.icon"
            class="editor-sidebar-nav__icon tw-h-5 tw-w-5"
          ></mat-icon>
        </span>
        <span
          class="editor-sidebar-nav__label tw-max-w-full tw-text-center tw-text-[11px] tw-font-medium tw-leading-4 tw-text-gray-700"
          >{{ item.label }}</span
        >
      </button>
    }
  </nav>

  <section
    class="editor-sidebar-panel tw-h-full tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-bg-white"
    aria-label="Editor panel"
  >
    <div
      class="attribute-list attribute-list-container te-scrollable-container tw-h-full sm:!tw-h-fit sm:!tw-max-h-full tw-pb-64 sm:!tw-pb-0"
      [ngClass]="{ 'attribute-list-hide': componentsFactory.selected }"
      [shown]="componentsFactory.showAttributeList"
    >
      <div
        class="editor-panel-header tw-flex tw-items-center tw-gap-3 tw-mt-10 !tw-mb-0 !tw-pb-0"
      >
        <button
          type="button"
          class="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-black"
          aria-label="Back"
          (click)="closeSidebarPanel()"
        >
          <mat-icon
            aria-hidden="true"
            svgIcon="arrow-left"
            class="tw-h-5 tw-w-5"
          ></mat-icon>
        </button>
        <h2 class="tw-m-0 tw-text-[16px] tw-font-bold tw-leading-6">Layers</h2>
      </div>
      <template-attribute-list></template-attribute-list>
    </div>

    <div
      class="attribute-component tw-h-full tw-overflow-hidden"
      [shown]="isTextAddPanelVisible()"
    >
      <div
        class="editor-panel-header tw-flex tw-items-center tw-gap-3 tw-mt-10"
      >
        <button
          type="button"
          class="tw-flex tw-h-8 tw-w-8 tw-min-w-8 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-black"
          aria-label="Back"
          (click)="closeSidebarPanel()"
        >
          <mat-icon
            aria-hidden="true"
            svgIcon="arrow-left"
            class="tw-h-5 tw-w-5"
          ></mat-icon>
        </button>
        <h2
          class="u_text-ellipsis mr-auto tw-m-0 tw-text-[16px] tw-font-bold tw-leading-6"
          role="heading"
          aria-level="2"
        >
          Text
        </h2>
      </div>

      <div class="attribute-editor-component text-add-panel">
        <div class="attribute-editor-component">
          <div class="attribute-editor-row">
            <button
              type="button"
              class="text-add-panel__primary-button tw-flex tw-h-[40px] tw-w-full tw-items-center tw-justify-center tw-gap-[16px] tw-rounded-[4px] tw-border-0 tw-text-[14px] tw-font-bold"
              (click)="addTextBox()"
            >
              <mat-icon
                svgIcon="editor-text"
                aria-hidden="true"
                class="editor-sidebar-panel__button-icon tw-h-5 tw-w-5"
              ></mat-icon>
              Add a text box
            </button>

            <div
              class="text-add-panel__styles"
              aria-labelledby="default-text-styles-heading"
            >
              <h3
                id="default-text-styles-heading"
                class="tw-m-0 tw-text-[14px] tw-font-bold tw-leading-[20px]"
              >
                Default text styles
              </h3>
              @for (preset of textPresets; track preset.id) {
                <button
                  type="button"
                  class="text-add-panel__preset-button"
                  [class.text-add-panel__preset-button--heading]="
                    preset.id === 'heading'
                  "
                  [class.text-add-panel__preset-button--subheading]="
                    preset.id === 'subheading'
                  "
                  [class.text-add-panel__preset-button--body]="
                    preset.id === 'body'
                  "
                  (click)="addTextPreset(preset)"
                >
                  {{ preset.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="attribute-component tw-h-full tw-overflow-hidden"
      [ngClass]="{
        'back-title-component': componentsFactory.isBackTitleHeaderVisible(
          componentsFactory.selected
        ),
      }"
      [shown]="isComponentSettingsVisible()"
    >
      <template-component></template-component>
    </div>
  </section>
</div>
